import React from 'react';
import { get } from 'lodash';

const hasErrorMessage = ({}: any) => {};

export function ErrorMessage({ touched, errors, name, children }: any) {
  const error = get(errors, name);
  const touch = get(touched, name);

  return error && touch ? error : null;
}
